import { render, staticRenderFns } from "./SignImg.vue?vue&type=template&id=21f0dbca&scoped=true"
import script from "./SignImg.vue?vue&type=script&lang=js"
export * from "./SignImg.vue?vue&type=script&lang=js"
import style0 from "./SignImg.vue?vue&type=style&index=0&id=21f0dbca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f0dbca",
  null
  
)

export default component.exports